<template lang="pug">
  div
    Header
    .about
      .about-main
        .about-avatar
          img(class="img-avatar" src="/img/avatar_r.jpg")
        .about-mail raenyu168@gmail.com
        .about-special-wrap
          .about-special
            .about-special-digit 12+
            .about-special-text Years ID
              br
              | experience
          .about-special
            .about-special-digit 23
            .about-special-text Design
              br
              | Categories
          .about-special
            .about-special-digit 103
            .about-special-text Design
              br
              | Projects
      .about-lists
        .about-lists-item
          h1.about-item-title Profile
          p.about-item-content Experienced Industrial Designer with a demonstrated history of working in the design industry. Skilled in Sketching, Product Design, PTC Creo, Rhino, C4D and Concept Development. Strong designing professional with a Master's degree focused in Industrial and Product Design from Tunghai University.

        .about-lists-item
          h1.about-item-title Honors
          ul.about-item-content
            li 2019 Reddot Design Award
            li 2019 iF Design Award
            li 2017 Good Design Award
            li 2016 Innovate eHealth solution Award
            li 2012 Golden Pin Award
            li 2012 Taiwanese’ Design Week Rising Star
            li 2012 Rii Exhibition

        .about-lists-item
          h1.about-item-title Patents
          ul.about-item-content
            li 2019 Adjustable Kettle Bell
            li 2019 Adjustable Dumb Bell
            li 2013 eSPORT wireless speaker
</template>

<script>
import Header from "@/components/header";

export default {
  components: {
    Header
  }
};
</script>

<style lang="sass">

.about
  width: calc(100% - 30px)
  display: flex
  flex-flow: row nowrap
  margin: 0 auto

.about-avatar
  width: 180px
  height: 180px
  margin: 0 auto
  img
    max-width: 180px
    width: 100%;
    height: 100%;

.about-mail
  display: inline-block;
  width: 180px
  margin: 7px auto 80px
  text-align: right
  font-size: 14px
  &::before
    display: inline-block;
    vertical-align: middle
    content: '\2709'
    font-size: 24px
    padding-right: 6px

.about-special
  display: flex
  flex-flow: row nowrap
  width: 60%
  align-items: center
  margin: 0 auto 15px

.about-special-digit
  position: relative
  font-size: 72px
  font-weight: bold
  width: 48%
  margin-right: 24px
  text-align: right
  &::before
    position: absolute
    right: -14px
    top: 29px
    content: ''
    width: 1px
    background-color: #333
    height: 40%

.about-special-text
  text-align: left

.about-main
  flex: 1 0 35%

.about-lists
  flex: 1 0 65%
  text-align: left

.about-lists-item
  margin-bottom: 48px

.about-item-title
  margin: 0 0 14px

.about-item-content
  line-height: 32px
  max-width: 700px
  li
    line-height: 26px

@media only screen and (max-width: 980px)
  .about
    flex-flow: row wrap

  .about-main
    flex: 1 0 100%
    margin-bottom: 60px

  .about-mail
    text-align: center

  .about-special-wrap
    max-width: 720px
    display: flex
    flex-flow: row nowrap
    margin: 0 auto
    justify-content: center

  .about-special
    margin: 0
    flex: 1 0 100px

  .about-lists
    flex: 1 0 100%
    text-align: center

  .about-lists-item
    margin-bottom: 60px

  .about-item-content
    max-width: 80%
    margin: 0 auto

@media only screen and (max-width: 567px)
  .about-mail
    margin-bottom: 60px
  .about-special
    margin-left: 6px
    flex: 1 1 auto
    display: flex
    justify-content: center
    &:first-child,
      margin-left: 0px
  .about-special-digit
    font-size: 32px
    margin-right: 10px
    width: auto
    &::before
      right: -4px
      top: 13px
  .about-special-text
    font-size: 12px
</style>
